/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCycle.ts                         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/cycle";

export class AutogenModelCycle<RowType extends ModelRow> extends Endpoint<RowType, RowCycleFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCycle extends ModelRow<RowCycleFields> {
	constructor(values?: Partial<RowCycleFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCycleFields {
	company_id: string;
	cycle_type: string;
	descr: string;
	id: string;
	min_date1: string;
	min_date2: string;
	quarter_date: string;
	quarter_month: string;
}

